export function modules($, slick, TweenLite) {

	//----------------------------------------------------
	// Slick carousel
	//----------------------------------------------------
  $('.js--slider').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    appendDots : $('.slider__dots')
  });

	//----------------------------------------------------
	// Select programming day
	//----------------------------------------------------

  $('.js-select-programming-day').change(function() {
    var target = this.options[this.selectedIndex].value;
    if (target === "") {
      $('.programming__page').show();
    } else {
      $('#'+target).show().siblings().hide();
    }
  });

  /*if ($('.js--slider').length) {
    TweenMax.to("#stop1", 5, { attr: {"stop-color":"#15C8FF",  "stop-color":"#3F61FE"}, ease: Linear.easeNone, repeat: -1, yoyo: true })
    TweenMax.to("#stop2", 5, { attr: {"stop-color":"#3F61FE",  "stop-color":"#030E8F"}, ease: Linear.easeNone, repeat: -1, yoyo: true })
    TweenMax.to("#stop3", 5, { attr: {"stop-color":"#030E8F",  "stop-color":"#07010D"}, ease: Linear.easeNone, repeat: -1, yoyo: true })
    TweenMax.to("#stop4", 5, { attr: {"stop-color":"#07010D",  "stop-color":"#15C8FF"}, ease: Linear.easeNone, repeat: -1, yoyo: true })
  }*/

  $('.select-categories').change(function () {
    document.location.href=this.options[this.selectedIndex].value;
  });
  function resizeCalendarByAreas() {
    $('.calendar__subrow__item--event[data-day-index]').each(function(i,e) {
      let currentIndex = Number($(e).attr('data-day-index'));
      let hasParentsWider = $(e).prevAll('[data-wider]').length;

      if (!hasParentsWider && currentIndex > 0) {
        let prevElemHeight = $(e).prev().height() + $(e).prev().position().top;
        $(e).css('top', prevElemHeight);
      } else if (hasParentsWider && currentIndex === 0) {
        let prevElemHeight = $(e).prevAll('[data-wider]').height() + $(e).prevAll('[data-wider]').position().top;
        $(e).css('top', prevElemHeight);
      } else if (hasParentsWider && currentIndex > 0) {
        let prevFirst = $(e).prev('[data-day-index]');

        let prevElemHeightSingle = (prevFirst.length) ? $(e).prev('[data-day-index]').height() + $(e).prev('[data-day-index]').position().top : 0;
        let prevUntil = $(e).prevUntil('[data-day-index]');
        let prevElemHeight = (prevUntil.length) ? prevElemHeightSingle + $(e).prevUntil('[data-day-index]').height() + $(e).prevUntil('[data-day-index]').position().top : prevElemHeightSingle;
        $(e).css('top', prevElemHeight);
      }
    });
  }
  resizeCalendarByAreas();

  function stickyCalendarHeader(calendar) {
    let stickyElem = calendar.find('.calendar__subrow--category');
    let marginLeft = 40 + calendar.scrollLeft();
    stickyElem.css('margin-left', marginLeft);
  }

  $('.calendar__row--cat').each(function(i,e) {
    let allIndex = $(e).find('[data-day-index]');
    let maxIndex = 0;
    let height = 0;

    if (allIndex.length) {
      let allIndexArray = [0];
      allIndex.each(function(x, c) {
        let dayIndex = Number($(c).attr('data-day-index'));
        allIndexArray.push(dayIndex);
      });

      maxIndex = Math.max( ...allIndexArray );
      height = Math.ceil((maxIndex + 1 ) * 1.5);

    } else {
      maxIndex = $(e).find('.calendar__subrow__item--event').length;
      height = maxIndex;
    }

    $(e).addClass('height--'+height);

  });

  $('.calendar--byarea').each(function(i,e) {
    stickyCalendarHeader($(e));
  });

  $('.calendar--byarea').scroll(function() {
    stickyCalendarHeader($(this));
  });

  let slickOptionsCalendar = {
    dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite : false,
    responsive: [
      {
        breakpoint: 1010,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true,
          infinite : false
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite : false
        }
      }
    ]
  };

  $('[data-gotodate]').click(function(e) {
    e.preventDefault();
    let date = $(this).attr('data-gotodate');
    $(this).addClass('active').siblings().removeClass('active');
    $('[data-datetarget="'+date+'"]').addClass('active').siblings().removeClass('active');

    $('[data-datetarget="'+date+'"] .calendar__page__inner').slick(slickOptionsCalendar);

  });
  $('[data-gotodate]:first-child').addClass('active');
  $('[data-datetarget]:first-child').addClass('active');


  $('.calendar__page:first-child .calendar__page__inner').slick(slickOptionsCalendar);

  $('#calendarview1').addClass('checked').prop('checked', true);
  $('#calendarbydate').hide();

  $('[name="calendarview"]').change(function() {

    if ($(this).is(':checked')) {
      $(this).addClass('checked');
      let currentTarget = $(this).attr('data-target');
      $(currentTarget).show().siblings('.calendar').hide();
      resizeCalendarByAreas();

      if (currentTarget === '#calendarbyarea') {
        $('#calendarbyarea-filters').show();
      } else {
        $('#calendarbyarea-filters').hide();
        $('.calendar__page:first-child .calendar__page__inner').slick("refresh");

      }
      $('[name="calendarview"]').not(this).removeClass('checked');

    }

  });

  $(window).on('resize orientationchange', function(){
    resizeCalendarByAreas();
  });

}
